import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { IntlProvider } from "react-intl";
import { RouterProvider } from "react-router-dom";
import router from "./router/router";
import { AppContext, useAppContext } from "@/common/hooks/useAppContext";
import { Locales } from "@/lang/types";
import { useMessages } from "@/lang/useMessages";
import { LoaderPage } from "@/shared/ui/LoaderPage";

const queryClient = new QueryClient();

export function App() {
  const context = useAppContext();
  const { messages } = useMessages(context.lang);

  return (
    <AppContext.Provider value={context}>
      <IntlProvider
        locale={context.lang}
        defaultLocale={Locales.ru}
        messages={messages}
        onError={() => null}
      >
        <QueryClientProvider client={queryClient}>
          <RouterProvider
            router={router(queryClient)}
            fallbackElement={<LoaderPage isLoading={true} />}
          />
        </QueryClientProvider>
      </IntlProvider>
    </AppContext.Provider>
  );
}
